<template>
  <div v-show="tabs.length > 0">
    <v-tabs v-model="tab" fixed-tabs center-active show-arrows>
      <v-tab v-for="tab in tabs" :key="tab.route" :to="tab.route" flat>
        {{ tab.name }}
      </v-tab>
    </v-tabs>
    <v-divider></v-divider>
  </div>
</template>
<script>
export default {
  data: () => ({
    tabs: [],
    tab: 0,
  }),

  created() {
    this.checkTabs();
  },

  watch: {
    $route() {
      this.checkTabs();
    },
  },

  methods: {
    checkTabs() {
      const showCpa = true;

      if (this.$prefix() === "colab") {
        if (this.$route.path.includes("/affiliates/affiliatesReports/payments")) {
          const suffix = "/collaborator/affiliates/affiliatesReports/payments";

          this.tabs = [];

          if (this.$permission("105")) {
            this.tabs.push({
              name: this.$t("payments.pay"),
              route: `${suffix}/pay`,
            });
          }

          if (this.$permission("106")) {
            this.tabs.push({
              name: this.$t("payments.historic"),
              route: `${suffix}/historic`,
            });
          }

          this.tab = 0;
        } else if (
          this.$route.path.includes("/affiliates/affiliatesReports/extract") &&
          showCpa
        ) {
          const suffix = "/collaborator/affiliates/affiliatesReports/extract";

          this.tabs = [];

          if (this.$permission("61")) {
            this.tabs.push({
              name: "Revenue Share",
              route: `${suffix}/revenueShare`,
            });
          }

          if (this.$permission("122")) {
            this.tabs.push({
              name: this.$t("cpaLabel"),
              route: `${suffix}/cpa`,
            });
          }

          this.tab = 0;
        } else {
          this.tabs = [];
        }
      } else {
        // adm
        if (this.$route.path.includes("/affiliates/payments")) {
          this.tabs = [
            {
              name: this.$t("payments.pay"),
              route:
                "/administrator/administratorAffiliates/affiliatesReports/affiliates/affiliates/payments/pay",
            },
            {
              name: this.$t("payments.historic"),
              route:
                "/administrator/administratorAffiliates/affiliatesReports/affiliates/affiliates/payments/historic",
            },
          ];

          this.tab = 0;
        } else if (this.$route.path.includes("invoices")) {
          this.tabs = [
            {
              name: this.$t("newInvoices.name"),
              route: "/administrator/system/invoices/newInvoices",
            },
            {
              name: this.$t("newInvoices.oldInvoices"),
              route: "/administrator/system/invoices/oldInvoices",
            },
          ];
          this.tab = 0;
        } else if (
          this.$route.path.includes("/affiliates/adminOnlineOnlineExtract") &&
          showCpa
        ) {
          const suffix =
            this.$prefix() === "colab"
              ? "/collaborator/affiliates/affiliatesReports/extract"
              : "/administrator/administratorAffiliates/affiliatesReports/affiliates/adminOnlineOnlineExtract";

          this.tabs = [
            {
              name: "Revenue Share",
              route: `${suffix}/revenueShare`,
            },
            {
              name: this.$t("cpaLabel"),
              route: `${suffix}/cpa`,
            },
          ];
          this.tab = 0;
        } else if (
          this.$route.path.includes("/regional-manager/affiliates") &&
          showCpa
        ) {
          const suffix = "/regional-manager/affiliates/extract";

          this.tabs = [
            {
              name: "Revenue Share",
              route: `${suffix}/revenueShare`,
            },
            {
              name: this.$t("cpaLabel"),
              route: `${suffix}/cpa`,
            },
          ];
          this.tab = 0;
        } else if (
          this.$route.path.includes("/local-manager/affiliates") &&
          showCpa
        ) {
          const suffix = "/local-manager/affiliates/extract";

          this.tabs = [
            {
              name: "Revenue Share",
              route: `${suffix}/revenueShare`,
            },
            {
              name: this.$t("cpaLabel"),
              route: `${suffix}/cpa`,
            },
          ];
          this.tab = 0;
        } else {
          this.tabs = [];
        }
      }
    },
  },
};
</script>
